export const regionnames: { [key: string]: string } = {
  CH031: 'Basel-Stadt',
  CH032: 'Basel-Landschaft',
  CH070: 'Tessin',
  CH024: 'Neuenburg',
  CH012: 'Wallis',
  CH011: 'Waadt',
  CH040: 'Zürich'
}
